(() => {
  if (window.amProductNavigationLoaded) return;
  window.amProductNavigationLoaded = true;
  const productHandle = path => path.match(/\/products\/([^/]+)\/?$/)?.[1];
  const collectionHandle = path => path.match(/\/collections\/([^/]+)(?:\/products\/[^/]+)?\/?$/)?.[1];
  const main = document.querySelector('main');
  const context = document.querySelector('[data-am-collection-context]')?.dataset.handle;

  // Encode context in the link itself: ordinary clicks, keyboard and new tabs work.
  function decorate(scope) {
    if (!main || !scope?.querySelectorAll) return;
    scope.querySelectorAll('a[href]').forEach(link => {
      if (!main.contains(link)) return;
      const source = link.closest('[data-am-collection-source]')?.dataset.amCollectionSource || context;
      if (!source) return;
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.origin !== location.origin || !productHandle(url.pathname)) return;
        url.searchParams.set('am_from', source);
        const href = url.pathname + url.search + url.hash;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      } catch (_) { /* Leave invalid or non-HTTP links alone. */ }
    });
  }
  decorate(main);
  if (main) new MutationObserver(() => decorate(main)).observe(main, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link && main?.contains(link)) decorate(link.parentElement);
  }, true);
  document.addEventListener('contextmenu', event => {
    const link = event.target.closest?.('a[href]');
    if (link && main?.contains(link)) decorate(link.parentElement);
  }, true);

  const nav = document.querySelector('[data-am-product-breadcrumb]');
  const product = document.querySelector('product-info[id^="MainProduct-"]');
  if (!nav || !product) return;
  product.classList.add('am-product-page');
  product.before(nav);
  const paths = [...nav.querySelectorAll('[data-am-path]')].flatMap(node => {
    try {
      const path = JSON.parse(node.dataset.amPath);
      if (!Array.isArray(path) || path.length > 3) return [];
      if (!path.every(item => {
        const url = new URL(item.url, location.href);
        return typeof item.title === 'string' && typeof item.handle === 'string' &&
          url.origin === location.origin && collectionHandle(url.pathname) === item.handle && !productHandle(url.pathname);
      })) return [];
      return [path];
    } catch (_) { return []; }
  });
  const current = new URL(location.href);
  let source = current.searchParams.get('am_from') || collectionHandle(current.pathname);
  if (!source && document.referrer) {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === location.origin && !productHandle(referrer.pathname)) source = collectionHandle(referrer.pathname);
    } catch (_) { /* Direct arrival uses the minimal breadcrumb. */ }
  }
  const match = paths.find(path => path.some(item => item.handle === source));
  const trail = match ? match.slice(0, match.findIndex(item => item.handle === source) + 1) : [];
  const list = nav.querySelector('ol');
  const title = list.querySelector('[aria-current="page"]').textContent;
  list.replaceChildren();
  const add = (label, href) => {
    const li = document.createElement('li');
    const element = document.createElement(href ? 'a' : 'span');
    element.textContent = label;
    if (href) element.href = href;
    else element.setAttribute('aria-current', 'page');
    li.append(element); list.append(li);
  };
  add('Home', nav.dataset.home);
  trail.forEach(item => add(item.title, item.url));
  add(title);
  nav.querySelector('[data-am-product-paths]').remove();

  // Dawn can replace the URL when a variant changes. Keep only validated context.
  function preserveContext() {
    const url = new URL(location.href);
    if (!trail.length || productHandle(url.pathname) !== nav.dataset.product) return;
    if (url.searchParams.get('am_from') !== source) {
      url.searchParams.set('am_from', source);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  }
  preserveContext();
  new MutationObserver(preserveContext).observe(product, { childList: true, subtree: true });
})();
